import React, { useState, useEffect } from "react";
import ResumeHoc from "../../Components/Hoc/ResumeHoc";
import { useNavigate, useLocation } from "react-router-dom";
import Input from "../../Components/Input/Input";
import Button from "../../Components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { EDUCATION } from "../../Redux/ResumeReducer/ResumeTypes";
import { useDispatch, useSelector } from "react-redux";
import { getCandidateProfileById, getUserById, view_resume } from "../../Api/apiService";
import Modal from "../../Components/Modal/Modal";
import { toast, ToastContainer } from "react-toastify";
import LayoutHOC from "../../Components/Hoc/ResumeHoc";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper";
import { Col, DatePicker, Row } from "antd";
import ResumeSidebar from "../../Components/Sidebar/Resume-Sidebar";
import CreateResumeWrapper from "./components/Create-Resume-Wrapper";
import { ChevronDown, ChevronUp, Plus, Trash } from "lucide-react";
import InputWrapper from "../../Components/Input/Input-Wrapper";
import CustomInput from "../../Components/Input/Custom-Input";
import CustomizeButton from "../../Components/Button/Customize-Button";
import "./Education.css";
import LottieIcon from "../../Components/LottieIcon/LottieIcon";
import dayjs from "dayjs";
import { selectProfile } from "../../Redux/ResumeReducer/ResumeAction";
function Education() {
  const resume = useSelector((state) => state.resume);
  const selectedProfile = useSelector((state)=> state.resume.selectedProfile);
  console.log(resume, "this is resume from redux");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const profileId = new URLSearchParams(location.search).get("profileId");
  const candidateUserId = new URLSearchParams(location.search).get("candidateProfileId");

  const user = JSON.parse(localStorage.getItem("auth")) || { userId: "" };
  const savedEducationData = useSelector((state) => state.resume.profileData.education);

  console.log(savedEducationData, "this is saved education Data");
  const candidateId = localStorage.getItem("profileId") || "";
  const employeeId = localStorage.getItem("employeeId") || "";
  const role = localStorage.getItem("selectedRole") || "";
  const [resumeTitle, setResumeTitle] = useState("");
  const [educations, setEducations] = useState([
    {
      id: Date.now(),
      open: true,
      institution: "",
      course: "",
      startYear: "",
      endYear: "",
    },
  ]);



  const [userDetails, setUserDetails] = useState();



  const userDet = useSelector((state) => state.auth);
  const { userId } = userDet;

  const toggleOpen = (id) => {
    setEducations((prev) => prev.map((edu) => (edu.id === id ? { ...edu, open: !edu.open } : edu)));
  };

  // Add new block
  const addEducation = () => {
    const lastEdu = educations[educations.length - 1];

    // validation: check if any field is empty
    if (!lastEdu.institution.trim() || !lastEdu.course.trim() || !lastEdu.startYear.trim() || !lastEdu.endYear.trim()) {
      toast.error("Please fill all fields before adding another education", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setEducations((prev) => {
      const updated = prev.map((edu) => ({ ...edu, open: false }));

      const newEdu = {
        id: Date.now(),
        open: true,
        institution: "",
        course: "",
        startYear: "",
        endYear: "",
      };

      return [...updated, newEdu];
    });
  };

  const removeEducation = (id) => {
    setEducations((prev) => prev.filter((edu) => edu.id !== id));
  };

  const handleEducationChange = (id, field, value) => {
    setEducations((prev) => prev.map((edu) => (edu.id === id ? { ...edu, [field]: value } : edu)));
  };
  // ====== HELPERS ======
  // const saveField = (index, fieldName, value) => {
  //   const updatedFields = educationFields.map((field, i) => (i === index ? { ...field, [fieldName]: value } : field));
  //   setEducationFields(updatedFields);

  //   // update redux right away so persistence works across sidebar navigation
  //   const formattedEducation = updatedFields.map((edu) => ({
  //     collegeName: edu.institutionName,
  //     course: edu.course,
  //     duration: `${edu.startDate} - ${edu.endDate}`,
  //   }));
  //   dispatch({ type: EDUCATION, payload: formattedEducation });
  // };

  const saveField = (id, fieldName, value) => {
    setEducations((prev) => prev.map((edu) => (edu.id === id ? { ...edu, [fieldName]: value } : edu)));
  };

  //   const saveField = (id, fieldName, value) => {
  //   // update educations
  //   const updatedEducations = educations.map((edu) =>
  //     edu.id === id ? { ...edu, [fieldName]: value } : edu
  //   );
  //   setEducations(updatedEducations);

  //   // format for redux
  //   const formattedEducation = updatedEducations.map((edu) => ({
  //     collegeName: edu.institution,
  //     course: edu.course,
  //     duration: `${edu.startYear} - ${edu.endYear}`,
  //   }));

  //   dispatch({ type: EDUCATION, payload: formattedEducation });
  // };

  // ====== FETCH FUNCTIONS ======
const getCandidateDetails = async () => {
  console.log("getCandidateDetails called");

  const education = resume?.profileData?.education || [];
  console.log(education, "education from redux");

  // ✅ If education data already exists in Redux, use it directly
  if (education.length > 0) {
    console.log("Loading education from Redux");

    const formattedEducationFields = education.map((edu, index) => {
      let startYear = "";
      let endYear = "";

      if (edu.duration) {
        const [start, end] = edu.duration.split(" - ");
        startYear = start?.trim() || "";
        endYear = end?.trim() || "";
      }

      return {
        id: `edu-${Date.now()}-${index}-${Math.random()}`, // ✅ Unique ID
        open: index === education.length - 1, // Only open last one
        institution: edu.collegeName || "",
        course: edu.course || "",
        startYear,
        endYear,
      };
    });

    setEducations(formattedEducationFields);
    return;
  }

  // ❌ Otherwise, fetch data from API
  console.log("Fetching education from API...");
  try {
    const response = await getCandidateProfileById(candidateId);
    if (response?.status === 200 || response?.status === 201) {
      const profile = response.data.profileData;
      setResumeTitle(response.data.resumeTitle || "");
      const educationData = profile?.education || [];

      if (educationData.length > 0) {
        const formattedEducationFields = educationData.map((edu, index) => {
          let startYear = "";
          let endYear = "";

          if (edu.duration) {
            const [start, end] = edu.duration.split(" - ");
            startYear = start?.trim() || "";
            endYear = end?.trim() || "";
          }

          return {
            id: `edu-${Date.now()}-${index}-${Math.random()}`, // ✅ Unique ID
            open: index === educationData.length - 1,
            institution: edu.collegeName || "",
            course: edu.course || "",
            startYear,
            endYear,
          };
        });

        console.log(formattedEducationFields, "formatted from API");
        setEducations(formattedEducationFields);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong.", {
      autoClose: 2000,
    });
  }
};
useEffect(() => {
  if (selectedProfile?.profileData?.education && selectedProfile.profileData.education.length > 0) {
    const formattedFields = selectedProfile.profileData.education.map((edu) => {
      const [startDate, endDate] = edu.duration ? edu.duration.split(" - ") : ["", ""];
      return {
        institution: edu.collegeName || "",
        course: edu.course || "",
        startYear: startDate || "",
        endYear: endDate || "",
        collapsed: false,
      };
    });
    setEducations(formattedFields);
  }
}, [selectedProfile]);


  const getUserDetails = async () => {
    try {
      const response = await getUserById(role === "employee" ? user.userId : userId);
      if (response?.status === 200 || response?.status === 201) {
        setUserDetails(response.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };


  // ====== USE EFFECTS ======
  useEffect(() => {
    if (role !== "candidate") {
      getUserDetails();
    } else {
      getCandidateDetails();
    }
  }, []);


  const handleNextClick = () => {
    // build payload from local educations

    
    const formattedEducation = educations
      .map((edu) => ({
        collegeName: (edu.institution || "").trim(),
        course: (edu.course || "").trim(),
        duration: edu.startYear && edu.endYear ? `${edu.startYear} - ${edu.endYear}` : edu.startYear || edu.endYear || "",
      }))
      .filter((e) => e.collegeName || e.course || e.duration); // remove empty rows

    // dispatch once here

    console.log(formattedEducation, "formatted education on next click");
    dispatch({ type: EDUCATION, payload: formattedEducation });

    if (selectedProfile) {
    dispatch(selectProfile({
      ...selectedProfile,
      profileData: {
        ...selectedProfile.profileData,
        education: formattedEducation,
      },
    }));
  }

    // then navigate
    if (role === "employee") {
      navigate(profileId ? `/professionalExperience?profileId=${profileId}` : "/professionalExperience");
    } else if (role === "candidate") {
      navigate(`/professionalExperience?candidateProfileId=${candidateId}`);
    } else {
      navigate(profileId ? `/professionalExperience?profileId=${profileId}` : "/professionalExperience");
    }
  };

  const handlePrevClick = () => {
    if (role === "employee") {
      navigate(profileId ? `/personalInfo?profileId=${profileId}` : "/personalInfo");
    } else if (role === "candidate") {
      navigate(`/personalInfo?candidateProfileId=${candidateUserId}`);
    } else {
      navigate(profileId ? `/personalInfo?profileId=${profileId}` : "/personalInfo");
    }
  };

  
  const handleCancel = () => {
      navigate(user?.role === "ROLE_HR"  ? "/dashboardHr" : "/dashboard");
  }

  console.log(educations, "this is educations");

  // ====== RENDER ======
  return (
    <>
      <ContainerWrapper breadcrumbItems={["Resume Builder", "Education"]}>
        <Row gutter={[20, 20]}>
          <Col span={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <ResumeSidebar title={resumeTitle ||selectedProfile?.jobTitle ||"Resume Title"} />
              </div>
            </div>
          </Col>
          <Col span={18}>
            <CreateResumeWrapper title={"Education"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  {educations.map((edu, index) => (
                    <Row
                      style={{
                        borderRadius: "10px",
                        padding: "16px",
                        border: "1px solid #E8E8E8",
                        marginBottom: "12px",
                      }}
                    >
                      <Row style={{ width: "100%" }}>
                        <Col
                          span={24}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                            paddingRight: "10px",
                          }}
                        >
                          <Row
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    color: "#000000",
                                  }}
                                >
                                  {edu.course || "Course"} at {edu.institution || "Institution"}
                                </span>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#8B8B8B",
                                  }}
                                >
                                  {edu.startYear && edu.endYear
                                    ? `${dayjs(edu.startYear, "DD-MM-YYYY").format("MMM YYYY")} - ${dayjs(edu.endYear, "DD-MM-YYYY").format(
                                        "MMM YYYY"
                                      )}`
                                    : "From - To"}
                                </span>
                              </div>

                              <div style={{ cursor: "pointer", display: "flex" }} onClick={() => toggleOpen(edu.id)}>
                                {educations.length > 1 && index !== educations.length - 1 && (
                                  <div
                                    style={{ marginLeft: "8px", cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeEducation(edu.id);
                                    }}
                                  >
                                    <LottieIcon name="trashIcon" size={24} />
                                  </div>
                                )}
                                {edu.open ? <ChevronUp /> : <ChevronDown />}
                              </div>
                            </div>
                            <div className={`education-collapse ${edu.open ? "open" : ""}`}>
                              <Row
                                style={{
                                  width: "100%",
                                  marginTop: "20px",
                                }}
                              >
                                <Col span={12} style={{ paddingRight: "10px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <InputWrapper label={"Institution Name"} required>
                                      <CustomInput
                                        value={edu.institution}
                                        onChange={(e) => saveField(edu.id, "institution", e.target.value)}
                                      ></CustomInput>
                                    </InputWrapper>

                                    <InputWrapper label={"Start Year"} required>
                                      <DatePicker
                                        onChange={(date, dateString) => saveField(edu.id, "startYear", dateString)}
                                        style={{
                                          height: "46px",
                                          borderRadius: "10px",
                                          border: "1px solid #E8E8E8",
                                          boxShadow: "none",
                                          width: "100%",
                                        }}
                                        value={edu.startYear ? dayjs(edu.startYear, "DD-MM-YYYY") : null}
                                        format="DD-MM-YYYY"
                                        placeholder=""
                                      />
                                    </InputWrapper>
                                  </div>
                                </Col>
                                <Col span={12} style={{ paddingLeft: "10px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <InputWrapper label={"Course Name"} required>
                                      <CustomInput value={edu.course} onChange={(e) => saveField(edu.id, "course", e.target.value)}></CustomInput>
                                    </InputWrapper>

                                    <InputWrapper label={"End Year"} required>
                                      <DatePicker
                                        onChange={(date, dateString) => saveField(edu.id, "endYear", dateString)}
                                        style={{
                                          height: "46px",
                                          borderRadius: "10px",
                                          border: "1px solid #E8E8E8",
                                          boxShadow: "none",
                                          width: "100%",
                                        }}
                                        value={edu.endYear ? dayjs(edu.endYear, "DD-MM-YYYY") : null}
                                        format="DD-MM-YYYY"
                                        placeholder=""
                                      />
                                    </InputWrapper>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </Row>
                  ))}
                  <div
                    style={{
                      color: "#910E11",
                      marginTop: "5px",
                      padding: "10px",
                      display: "flex",
                      cursor: "pointer",
                    }}
                    onClick={addEducation}
                  >
                    <div style={{ marginRight: "10px" }}>
                      <Plus size={20} />
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Add Another Education
                    </div>
                  </div>
                </div>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <CustomizeButton onClick={handleNextClick} variant="primary" style={{ width: "14rem" }}>
                    {" "}
                    Save & Next{" "}
                  </CustomizeButton>
                  <CustomizeButton onClick={handlePrevClick} variant="outlined" style={{ width: "14rem" }}>
                    {" "}
                    Previous
                  </CustomizeButton>
                  <CustomizeButton variant="outlined" style={{ width: "14rem" }} onClick={handleCancel}>
                    {" "}
                    Cancel
                  </CustomizeButton>
                </Row>
              </div>
            </CreateResumeWrapper>
          </Col>
        </Row>
        <ToastContainer />
      </ContainerWrapper>
    </>
    // <div className="resume-form">
    //   <div>
    //     <h1 className="resume-form-title">Education</h1>
    //     {loading && <p>Loading...</p>}
    //     {error && <p className="error">{error}</p>}

    //     <div className="resume-professional-experience">
    //       <div className="resume-form-header">
    //         <FontAwesomeIcon icon={faPlus} className="resume-plus-icon" onClick={handlePlusClick} />
    //       </div>

    //       <div className="resume-entry">
    //         {!educationFields[0].collapsed && (
    //           <>
    //             <div className="grid-container-2-col">
    //               <Input
    //                 label="Institution Name"
    //                 name="institutionName"
    //                 type="text"
    //                 className="resume-form-input-field"
    //                 value={educationFields[0].institutionName}
    //                 onChange={(e) => saveField(0, "institutionName", e.target.value)}
    //               />
    //               <Input
    //                 label="Course"
    //                 name="course"
    //                 type="text"
    //                 className="resume-form-input-field"
    //                 value={educationFields[0].course}
    //                 onChange={(e) => saveField(0, "course", e.target.value)}
    //               />
    //             </div>
    //             <div className="grid-container-2-col">
    //               <Input
    //                 label="Start Year"
    //                 name="startYear"
    //                 type="text"
    //                 className="resume-form-input-field"
    //                 value={educationFields[0].startDate}
    //                 onChange={(e) => saveField(0, "startDate", e.target.value)}
    //               />
    //               <Input
    //                 label="End Year"
    //                 name="endYear"
    //                 type="text"
    //                 className="resume-form-input-field"
    //                 value={educationFields[0].endDate}
    //                 onChange={(e) => saveField(0, "endDate", e.target.value)}
    //               />
    //             </div>
    //           </>
    //         )}
    //       </div>

    //       {educationFields.length > 1 && (
    //         <div className="education-table-container">
    //           <table className="education-table">
    //             <thead>
    //               <tr>
    //                 <th>Institution Name</th>
    //                 <th>Course</th>
    //                 <th>Start Year</th>
    //                 <th>End Year</th>
    //                 <th>Action</th>
    //               </tr>
    //             </thead>
    //             <tbody>
    //               {educationFields.slice(1).map((field, index) => (
    //                 <tr key={index + 1}>
    //                   <td>{field.institutionName}</td>
    //                   <td>{field.course}</td>
    //                   <td>{field.startDate}</td>
    //                   <td>{field.endDate}</td>
    //                   <td>
    //                     <div className="table-icons">
    //                       <FontAwesomeIcon
    //                         icon={faEdit}
    //                         className="resume-edit-icon"
    //                         onClick={() => handleEditClick(index + 1)}
    //                       />
    //                       <FontAwesomeIcon
    //                         icon={faTrash}
    //                         className="resume-delete-icon"
    //                         onClick={() => handleDeleteClick(index + 1)}
    //                       />
    //                     </div>
    //                   </td>
    //                 </tr>
    //               ))}
    //             </tbody>
    //           </table>
    //         </div>
    //       )}
    //     </div>
    //   </div>

    //   <div className="resume-form-btn">

    //     <Button onClick={handlePrevClick}>Previous</Button>
    //     <Button onClick={handleNextClick}>Next</Button>
    //   </div>

    //   <Modal show={showModal} onClose={() => setShowModal(false)} width="400px" height="400px">
    //     <h2>Edit Education</h2>
    //     <Input
    //       label="Institution Name"
    //       name="institutionName"
    //       type="text"
    //       value={editField.institutionName}
    //       onChange={(e) => setEditField({ ...editField, institutionName: e.target.value })}
    //       className="modal-input"
    //     />
    //     <Input
    //       label="Course"
    //       name="course"
    //       type="text"
    //       value={editField.course}
    //       onChange={(e) => setEditField({ ...editField, course: e.target.value })}
    //       className="modal-input"
    //     />
    //     <div className="grid-container-2-col">
    //       <Input
    //         label="Start Year"
    //         name="startYear"
    //         type="text"
    //         value={editField.startDate}
    //         onChange={(e) => setEditField({ ...editField, startDate: e.target.value })}
    //         className="modal-input"
    //       />
    //       <Input
    //         label="End Year"
    //         name="endYear"
    //         type="text"
    //         value={editField.endDate}
    //         onChange={(e) => setEditField({ ...editField, endDate: e.target.value })}
    //         className="modal-input"
    //       />
    //     </div>
    //     <Button onClick={handleModalSave}>Save</Button>
    //   </Modal>
    // </div>
  );
}

export default LayoutHOC(Education, { withSidebar: true });
